module.exports = __webpack_public_path__ + "static/media/desktopScreenshot07.ffa8cccb.jpg";